var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeArcGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 83.5747,
    height: 100.207,
    viewBox: "0 0 83.5747 100.207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 528",
    d: "M83.3916 5.9854C82.4653 1.76323 78.2797 -0.937222 74.1388 0.302877C53.9824 6.33924 36.0562 18.3515 22.7864 34.8369C9.51664 51.3224 1.61163 71.4011 0.020992 92.3818C-0.305786 96.692 3.22653 100.204 7.54914 100.207V100.207C11.8717 100.21 15.3424 96.7011 15.7262 92.3955C17.2781 74.9862 23.9479 58.3582 34.9803 44.6523C46.0128 30.9464 60.8318 20.878 77.5077 15.6425C81.6318 14.3478 84.318 10.2076 83.3916 5.9854V5.9854Z",
    fill: "#6EC885"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeArcGreen);
export default __webpack_public_path__ + "static/media/gauge-arc-green.2e7e20b84ad6b5c268afc8b2b47b1d4b.svg";
export { ForwardRef as ReactComponent };